import { Component } from "react";
import React from "react";
import "./Footer.css"

class Footer extends Component{
    render(){
        return <>
        <footer>
            Copyright 2022 mitul. All rights reserved.
        </footer>
        </>
    }
}

export default Footer